<script setup>
   import { ref, watchEffect, inject } from 'vue'
   const $storeViewLoading = inject('$storeViewLoading')

   const isLoading = ref(false)
   watchEffect(() => isLoading.value = $storeViewLoading.isLoading)
</script>

<template>
   <div class="loading-screen" :class="{ 'loading-finished': ! isLoading }">
      <span class="loader"></span>
   </div>
</template>

<style lang="scss" scoped>
.loading-screen {
   position: fixed;
   top: 0;
   left: 0;
   width: 100%;
   height: 100%;
   display: flex;
   justify-content: center;
   align-items: center;
   z-index: 9999;
   background: var(--bs-dark-bg);

   &.loading-finished {
      animation: loadingFadeOut .4s linear forwards;
   }
   @keyframes loadingFadeOut {
      0% {
         opacity: 1;
         visibility: visible;
         tranform: scale(1);
      }
      50% {
         opacity: 1;
         visibility: visible;
         tranform: scale(1);
      }
      100% {
         opacity: 0;
         visibility: hidden;
         transform: scale(2);
         // top: -100%;
      }
   }

   .loader {
      width: 100px;
      height: 100px;
      display: inline-block;
      position: relative;
   }
   .loader::after,
   .loader::before {
      content: '';
      box-sizing: border-box;
      width: 100px;
      height: 100px;
      border-radius: 50%;
      border: 2px solid #FFF;
      position: absolute;
      left: 0;
      top: 0;
      animation: animloader 2s linear infinite;
   }
   .loader::after {
      animation-delay: 1s;
   }

   @keyframes animloader {
      0% {
         transform: scale(0);
         opacity: 1;
      }
      100% {
         transform: scale(1);
         opacity: 0;
      }
   }
}
</style>